<template>
  <div>
    <!-- <PageAllow controller="" action="index" /> -->
    <Breadcrumbs :items="items" />
  </div>
</template>

<script>
import i18n from "@/i18n";
// import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";

export default {
  components: {
    // PageAllow,
    Breadcrumbs

  },
  computed:{
    items: () => [
      {
        text: i18n.t("Nav.home"),
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.reportDesign"),
        disabled: true,
        href: "/print-templates",
      },
    ],
  }
}
</script>

<style>

</style>